import { immerable } from 'immer'
import { useState, useRef } from 'react'
import api from '@/services/api/templates'
import titleCase from '@/utils/title-case'
import KeyHelper from '@/utils/key-helper'

class Template {

	[immerable] = true

	constructor(params) {
		this.name = params.name
		this.id = params.id
		this.dataElements = params.dataElements
		this.$selected = false
	}
}

const useTemplates = () => {

	const [items, setItems] = useState([])
	const [meta, setMeta] = useState(null)
	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	const lastRequestPayloadKeyRef = useRef(null)

	async function fetch(option) {
		const currentPayloadKey = KeyHelper.createKeyOfObject({ option })

		if(KeyHelper.isSameKey(lastRequestPayloadKeyRef.current, currentPayloadKey)) return;

		lastRequestPayloadKeyRef.current = currentPayloadKey

		setLoading(true)

		const params = option || {}

		const [error, response] = await api.index(params)

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!Array.isArray(response)) {
			return setError('Templates is not an array')
		}

		const serializedData = response.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new Template(params))

		setItems(newItems)
	}

	function serialize(entry) {
		return {
			id: entry.id,
			name: entry.name,
			dataElements: entry.dataElements,
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		currentItem,
		error,
		fetch,
		items,
		loading,
		meta,
		setCurrentItem,
		setItems,
		view,
	}

}

export default useTemplates
